import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { User } from '@k2/common/entities-state/types';

@Component({
    selector: 'user-autocomplete-option',
    templateUrl: 'user-autocomplete-option.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class UserAutocompleteOptionComponent {
  @Input() user: User;
  @Input() highlight: string;
}
